//Defininiciones de los recursos simples que se expresan con una sola linea

import kea = require('node_modules/kea-react/dist/index');
import models = require("app/models/requireme");
import { rpcController } from "../rpc";
import { cacheResource, bindResource, observeResource, rpcCrudService } from "kea-resource";

const controller = rpcController("Usuario");
const crud = rpcCrudService<models.Usuario, models.UsuarioDto>(controller);
const otros = cacheResource({
    /**
* Devuelve true si este nombre de usuario ya existe
* @param login 
*/
    UsuarioExiste: async (login: string): Promise<boolean> => await controller("UsuarioExiste", { login: login || "" }),
    query: async (filtro: models.FiltroUsuario): Promise<models.UsuarioDto[]> => await controller("Query", {}, filtro),
    /**Obtiene el IdSucursal dado un IdUsuario */
    ObtenerIdSucursalDeUsuario: async (idUsuario: number): Promise<number | null> => await controller('ObtenerIdSucursalDeUsuario', { idUsuario }),

    /**Remplaza un usuario */
    RemplazarUsuario: async (model: models.RemplazoUsuario): Promise<number> => await controller("RemplazarUsuario", {}, model),

}, {
        UsuarioExiste: true,
        query: true,
    }, {
        RemplazarUsuario: true
    });


export const Usuario = bindResource({ ...crud, ...otros });


// WEBPACK FOOTER //
// ./app/resources/items/usuario.ts